<template>
  <div id="contact-part">
    <div id='contact'>
      <div class="container text-center">
        <div class="row">
          <div class="col-md-4">
            <h3>Reservations</h3>
            <div class="contact-item">
              <p>Please call</p>
              <p>(887) 654-3210</p>
            </div>
          </div>
          <div class="col-md-4">
            <h3>Address</h3>
            <div class="contact-item">
              <p>4321 California St,</p>
              <p>San Francisco, CA 12345</p>
            </div>
          </div>
          <div class="col-md-4">
            <h3>Opening Hours</h3>
            <div class="contact-item">
              <p>Mon-Thurs: 10:00 AM - 11:00 PM</p>
              <p>Fri-Sun: 11:00 AM - 02:00 AM</p>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="section-title text-center">
          <h3>Send us a message</h3>
        </div>
        <div class="row">
          <div class="col-md-12">
            <form>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <input type="text" id="name" class="form-control" placeholder="Name">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <input type="email" id="email" class="form-control" placeholder="Email">
                  </div>
                </div>
              </div>
              <div class="form-group">
                <textarea name="message" id="message" class="form-control" rows="4" placeholder="Message"></textarea>
              </div>
              <button type="submit" class="btn btn-custom btn-lg">Send Message</button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div id="footer">
      <div class="container text-center">
        <div class="row">
          <div class="col-md-6">
            <p>&copy; 2017 Gusto. All rights reserved. Design by <a href="http://www.templatewire.com" rel="nofollow">TemplateWire</a></p>
          </div>
          <div class="col-md-6">
            <div class="social">
              <ul>
                <li><a href="#"><i class="fa fa-facebook"></i></a></li>
                <li><a href="#"><i class="fa fa-twitter"></i></a></li>
                <li><a href="#"><i class="fa fa-youtube"></i></a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Contact-part',
  data : function () {
    return {
      title : 'contact page',
    }
  } 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#contact {
	padding: 100px 0;
	background: #333;
}
#contact .contact-item p {
	font-size: 15px;
	color: #777;
}
#contact .section-title {
	margin-top: 60px;
	margin-bottom: 40px;
}
#contact form {
	padding: 0;
}
#contact h3 {
	position: relative;
	text-transform: uppercase;
	font-size: 18px;
	font-weight: 400;
	color: #aaa;
	padding: 20px 0;
}
#contact h3::after {
	position: absolute;
	content: "";
	background: #d43031;
	height: 2px;
	width: 40px;
	bottom: 0;
	margin-left: -20px;
	left: 50%;
}
#contact .text-danger {
	color: #cc0033;
	text-align: left;
}
label {
	font-size: 12px;
	font-weight: 400;
	font-family: 'Open Sans', sans-serif;
	float: left;
}
#contact .form-control {
	display: block;
	width: 100%;
	padding: 6px 12px;
	font-size: 16px;
	line-height: 1.42857143;
	color: #ccc;
	background-color: rgba(255,255,255,.2);
	background-image: none;
	border: 0;
	border-radius: 0;
	-webkit-box-shadow: none;
	box-shadow: none;
	-webkit-transition: none;
	-o-transition: none;
	transition: none;
}
#contact .form-control:focus {
	border-color: #999;
	outline: 0;
	-webkit-box-shadow: transparent;
	box-shadow: transparent;
}
.form-control::-webkit-input-placeholder {
color: #999;
}
.form-control:-moz-placeholder {
color: #999;
}
.form-control::-moz-placeholder {
color: #999;
}
.form-control:-ms-input-placeholder {
color: #999;
}
#contact .contact-item {
	margin: 20px 0 40px 0;
}
#contact .contact-item span {
	font-weight: 400;
	color: #aaa;
	text-transform: uppercase;
	margin-bottom: 6px;
	display: inline-block;
}
/* Footer Section*/
#footer {
	background: #262626;
	padding: 40px 0 20px 0;
}
#footer .social {
	margin-top: -5px;
	text-align: right;
}
#footer .social ul li {
	display: inline-block;
	margin: 0 15px;
}
#footer .social i.fa {
	font-size: 24px;
	padding: 4px;
	color: #888;
	transition: all 0.3s;
}
#footer .social i.fa:hover {
	color: #eee;
}
#footer p {
	font-size: 14px;
	color: #666;
}
#footer a {
	color: #999;
}
#footer a:hover {
	color: #eee;
}
</style>
